// Public "generic" api:
//
//  - showConsentDetails(serviceId) => void : opens the consent details dialog for the given serviceId
//  - hasConsent(serviceId) => boolean : returns true if the user has given consent for the given serviceId
//  - consentPromise(serviceId) => Promise<void> : returns a promise that resolves when the user has given consent for the given serviceId
//  - acceptAllConsents() => void : accepts all consents
//  - denyAllConsents() => void : denies all consents
//  - acceptConsent(serviceId) => void : accepts the consent for the given serviceId
//  - denyConsent(serviceId) => void : denies the consent for the given serviceId
//


export const UserCentricIds = {
    GOOGLE_MAPS: 'S1pcEj_jZX',
    GOOGLE_ANALYTICS: '87JYasXPF',
    GOOGLE_TAG_MANAGER: 'BJ59EidsWQ',
    LINKEDIN_ANALYTICS: 'BJikbq4iujWQ',
    LINKEDIN: 'Hkx754i_iWm',
    FACEBOOK_PIXEL: 'ko1w5PpFl',
    PINTEREST: '9Q2qrmB3',
    YOUTUBE: 'BJz7qNsdj-7',
    BILIBILI: '5VYidswcluSX9B',
    WIREDMINDS: 'HkdvTCJTN',
    INSTAGRAM: 'SyUQ54odobQ',
    FACEBOOK: 'XYQZBUojc',
    X: 'BJTzqNi_i-m',
    OPEN_AI: '8mZBsum_rVZF40'
}

export const showConsentDetails = (serviceId) => {
    window.UC_UI?.showSecondLayer(serviceId);
    return false;
}
window.showConsentDetails = showConsentDetails;

export const hasConsent = (serviceId) => {
    const services = window.UC_UI?.getServicesBaseInfo() ?? [];
    const service = services.find(s => s.id === serviceId);
    return service && service.consent && service.consent.status === true;
};

const consentPromisResolvers = new Map();
export const consentPromise = async(serviceId) => new Promise(resolve => {
    if (hasConsent(serviceId)) {
        resolve();
    }

    if (consentPromisResolvers.has(serviceId)) {
        consentPromisResolvers.get(serviceId).push(resolve);
    } else {
        consentPromisResolvers.set(serviceId, [resolve]);
    }
});
const checkResolvers = () => {
    consentPromisResolvers.forEach((resolvers, serviceId) => {
        if (hasConsent(serviceId)) {
            resolvers.forEach(resolve => resolve());
            consentPromisResolvers.delete(serviceId);
        }
    });
}

let consentInitResolve;
export const consentInitPromise = new Promise(resolve => {
    consentInitResolve = resolve;
});

export const getConsentName = (serviceId) => {
    const services = window.UC_UI?.getServicesBaseInfo() ?? [];
    const service = services.find(s => s.id === serviceId);
    return service?.name;
}



// Accepting / Denying
export const acceptAllConsents = async() => {
    log('acceptAllConsents called')
    if (!window.UC_UI) {
        return
    }
    await window.UC_UI.acceptAllConsents()
}
export const denyAllConsents = async() => {
    log('denyAllConsents called')
    if (!window.UC_UI) {
        return
    }
    await window.UC_UI.denyAllConsents()
}
export const acceptConsent = async(serviceId) => {
    log('acceptConsent called', serviceId)
    if (!window.UC_UI) {
        return
    }
    await window.UC_UI.acceptService(serviceId)
}
export const denyConsent = async(serviceId) => {
    log('denyConsent called', serviceId)
    if (!window.UC_UI) {
        return
    }
    await window.UC_UI.rejectService(serviceId)
}






// Constructor
(function initialize() {
    window.addEventListener('UC_UI_CMP_EVENT', function(event) {
        log('UC_UI_CMP_EVENT', event.detail.type);
        switch (event.detail.type) {
        case 'SAVE':
        case 'DENY_ALL':
        case 'ACCEPT_ALL':
            checkResolvers()
            break;
        }
    });

    if (window.UC_UI && window.UC_UI.isInitialized) {
        consentInitResolve();
        checkResolvers();
    }
    else {
        window.addEventListener('UC_UI_INITIALIZED', () => {
            consentInitResolve();
            checkResolvers();
        });
    }


    // Footer handling
    // Check for links in the footer with a href of "#privacy-settings".
    // Hijack the click event and open the usercentrics dialog instead.
    document.addEventListener("DOMContentLoaded", () => {
        const footer = document.querySelector('footer');
        if (!footer) {
            return;
        }

        const links = footer.querySelectorAll('a[href="#privacy-settings"]');
        links.forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();
                showConsentDetails();
            })
        });
    });
})()


// Utility functions

function log() {
    // console.log('[sal-usercentrics]', ...arguments)
}
